import Vue from 'vue';
import App from './index.vue';
//引入vuex
import Vuex from 'vuex';
import store from '../../store/store.js';
//引入vue路由
import VueRouter from 'vue-router';
import router from '../../router/router.js';
//引入axios
import axios from 'axios';
//引入element-ui样式
import 'element-ui/lib/theme-chalk/index.css';
// import "bootstrap/dist/css/bootstrap.css";
import "../../assets/css/bootstrap.css";
//引入font-awesome
import "font-awesome/css/font-awesome.min.css";
//引入样式
import '../../assets/css/main.css';
import '../../assets/css/style.css';
import '../../assets/css/cm-overlay.css';

//引入ElementUI
import ElementUI from 'element-ui';
//引入js
import $ from 'jquery'; //引入jquery
//引入bootstrap
// import "bootstrap/dist/js/bootstrap.min.js";
import "../../../public/js/bootstrap.js";
// 全局引入echarts
// import echarts from 'echarts';
// Vue.prototype.$echarts = echarts;

//使用Vuex
// Vue.use(Vuex);
//使用VueRouter
// Vue.use(VueRouter);
//使用ElementUI
Vue.use(ElementUI);
// , {
// 	i18n: (key, value) => i18n.t(key, value)
// }

axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api'; //接口请求默认前缀
Vue.prototype.$axios = axios; 		//axios绑定到vue上

Vue.config.productionTip = false

new Vue({
	router,
	// 把 store 对象提供给 “store” 选项，这可以把 store 的实例注入所有的子组件
	store,
	render: h => h(App),
}).$mount('#app')
